// Replace this URL if the Amazon link ever changes — it powers every "Buy the Book" button on the site.
export const AMAZON_URL = "https://www.amazon.com/dp/B0HHZ834J8";

export const NAV_LINKS = [
  { label: "Inside the Book", href: "#inside" },
  { label: "About the Book", href: "#about" },
  { label: "Free Sample", href: "#sample" },
  { label: "Meet the Author", href: "#author" },
];

export const BRAND = {
  turquoise: "#20C9C3",
  turquoiseDark: "#14A8A3",
  gold: "#C5A253",
  goldDark: "#A98841",
  ink: "#1E2A2B",
  paper: "#FFFFFF",
  sand: "#F6F5F0",
};
